import { useDispatch, useSelector } from 'react-redux';
import StructureEstimateForm from './StructureEstimateForm';
import { useEffect } from 'react';
import {
    // changeBody,
    initialize,
    changeStructure,
    changeWeightSummary,
} from '../../modules/conveyor/conveyorWriteSlice';
import { useCallback } from 'react';

import ButtonBackToList from '../common/ButtonBackToList';

const StructureEstimateFormContainer = () => {
    const dispatch = useDispatch();


    const title = useSelector(state => state.conveyorWrite.title);
    const body = useSelector(state => state.conveyorWrite.body);
    const project = useSelector(state => state.conveyorWrite.project);
    // const tags = useSelector(state => state.conveyorWrite.tags);
    // const user = useSelector(state => state.conveyorWrite.user);
    const conveyorType = useSelector(state => state.conveyorWrite.conveyorType);
    




    useEffect(() => {
        // 언마운트시 리덕스 스토어 writeConveyor 초기화
        return () => {
            dispatch(initialize());
        };
    }, [dispatch]);

    const onSaveStructure = useCallback(
        (payload) => {
            dispatch(changeStructure(payload));
        },
        [dispatch],
    );

    const onChangeWeightSummary = useCallback(
        (payload) => {
            // console.log('payload @ onChangeWeightSummary : ', payload);
            dispatch(changeWeightSummary(payload));
        },
        [dispatch],
    );

    /* 풀리를 저장하고 돌아온 리스트 화면에서 뒤로가기를 누르면 conveyorWrite에 아무런 정보가 없기 때문에 에러가 발생하게 된다. 
        리덕스에 conveyorWrite 정보가 없으면 즉, 제대로 된 루트로 이 화면에 들어온 것이 아니기 때문에 '리스트로 돌아가기' 버튼을 배치한다 */
        if (!title) {
            return (
                <ButtonBackToList to={`/projects/${project?._id}/structure`}>리스트로 돌아가기</ButtonBackToList>
            )
        }

    return (
        <StructureEstimateForm
            onSaveStructure={onSaveStructure}
            onChangeWeightSummary={onChangeWeightSummary}
            project={project}
            title={title}
            body={body}
            conveyorType={conveyorType}
        />
    );
};

export default StructureEstimateFormContainer;
